// extracted by mini-css-extract-plugin
module.exports = {"lia-message-subject":"MessageSubject_lia-message-subject__wTpW3"};